import { useEffect, useState } from "react";

/**
 * Return the current pixel height of the fixed public header
 * (`nav.fl-nav`) so sticky elements can sit *exactly* underneath it
 * without hard-coding `top-14 / top-16` guesses that drift on rerender
 * or when the header animates (e.g. on scroll shrink).
 */
export function useHeaderHeight() {
  const [h, setH] = useState(64);
  useEffect(() => {
    const el = document.querySelector("nav.fl-nav") || document.querySelector("header.fl-nav");
    if (!el) return;
    const measure = () => setH(el.getBoundingClientRect().height || 64);
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    window.addEventListener("resize", measure);
    return () => { ro.disconnect(); window.removeEventListener("resize", measure); };
  }, []);
  return h;
}

/** Return the height of an arbitrary sticky element referenced by ref. */
export function useElementHeight(ref) {
  const [h, setH] = useState(0);
  useEffect(() => {
    const el = ref?.current;
    if (!el) return;
    const measure = () => setH(el.getBoundingClientRect().height || 0);
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [ref]);
  return h;
}
